/* eslint-disable import/prefer-default-export */

import currency from 'currency.js';

export const getPrice = (price) => {
    const euro = (value) => currency(value, { symbol: '€ ', decimal: ',', separator: '.' });
    // const euro = (value) => currency(value, { separator: ',', decimal: ',' });
    const result = euro(price).format();

    // Replace trailing 00 with -
    const ending = result.slice(-2);
    if (ending == '00') {
        const newStr = result.slice(0, -2);
        return `${newStr}-`;
    }

    return result;
};
